import { get } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
// eslint-disable-next-line spire/fenced-imports
import { unparse } from "papaparse";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.pages.orderHistory.getOrdersParameter as any,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

export interface ExportOpenOrdersStyles {
    exportButton?: ButtonPresentationProps;
    spinner?: LoadingSpinnerProps;
}

export const exportOpenOrdersStyles: ExportOpenOrdersStyles = {
    exportButton: {
        css: css`
            span {
                pointer-events: none;
            }
        `,
    },
    spinner: {
        css: css`
            margin: auto 0 auto 10px;
        `,
    },
};
const styles = exportOpenOrdersStyles;

function ExportOpenOrders({ updateSearchFields, parameter }: any) {
    const [isExporting, setIsExporting] = React.useState(false);

    const handleClick = async () => {
        if (isExporting) {
            return;
        }

        setIsExporting(true);
        try {
            const res = (await get("/api/v1/customorders/openOrders")) as any;
            if (!res.openOrders) {
                return;
            }

            const fieldMappings: Record<string, string> = {
                iewcSalesOrderNumber: "IEWC Sales Order Number",
                iewcOrderLine: "IEWC Order Line",
                customerPoNumber: "Customer PO Number",
                customerPOItem: "Customer PO Item",
                customerPartNumber: "Customer Part Number",
                iewcPartNumber: "IEWC Part Number",
                quantity: "Quantity",
                customerRequestDate: "Customer Request Date",
                estimatedShipDate: "Estimated Ship Date",
                estimatedDeliveryDate: "Estimated Delivery Date",
                notes: "Notes",
            };

            const customColumnNames = Object.values(fieldMappings);

            const dataRows = res.openOrders.map((order: any) => {
                return Object.keys(fieldMappings).map((key: any) => {
                    return order[key];
                });
            });

            const csv = unparse([customColumnNames, ...dataRows]);
            const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

            const fileName = `${res.fileName}.csv`;
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(csvBlob);
            downloadLink.setAttribute("download", fileName);
            downloadLink.click();
        } finally {
            setIsExporting(false);
        }
    };

    if (isExporting) {
        return <LoadingSpinner {...styles.spinner} />;
    }

    return (
        <Button
            onClick={handleClick}
            variant="primary"
            className="verndaleGA4__export-order-btn"
            {...styles.exportButton}
        >
            {translate("Export open orders")}
        </Button>
    );
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ExportOpenOrders as any) as any,
    definition: {
        group: "Order History",
        displayName: "Export open orders",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
